import { sortReplies } from '@btime/helpers'
import React from 'react'

import { useGroupedRepliesByCategory } from '../../../containers/dynamic/presentationList/categories/_data/groupByCategories'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { useChildrenServiceOrders } from './_load/ChildrenServiceOrderLoader'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import { useReplies, useServiceOrder } from './_load/ServiceOrderLoader'
import { sumPointsByCategory } from './_helpers/sumPointsByCategory'
import Preview from '../../../components/pdf/Preview'
import { useResumeCounters } from './_data/counters'
import OptionsForm from './options/OptionsForm'
import PdfDocument from './PdfDocument'

const PageContent = () => {
  const serviceOrder = useServiceOrder()
  const replies = useReplies()
  const categories = useGroupedRepliesByCategory(sortReplies(replies))
  const counters = useResumeCounters()
  const childrenServiceOrders = useChildrenServiceOrders()
  const categoriesWithPoints = sumPointsByCategory(categories)

  const countersOfPoints = categoriesWithPoints.reduce((acc, catValue) => acc + catValue.totalOfPoints, 0)
  const countersOfValues = categoriesWithPoints.reduce((acc, catValue) => acc + catValue.totalOfValues, 0)

  const props = {
    serviceOrder,
    categories: categoriesWithPoints,
    counters: { ...counters, countersOfPoints, countersOfValues },
    childrenServiceOrders
  }

  return (
    <PdfOptionsFormHandler>
      <FlexGrid align="stretch">
        <FlexCol flex={3} invisibleOn="mdd">
          <Preview>
            <PdfDocument {...props} />
          </Preview>
        </FlexCol>

        <FlexCol flex={1}>
          <OptionsForm />
        </FlexCol>
      </FlexGrid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
